import React from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import ErrorIcon from '@material-ui/icons/ErrorRounded';

import { styles } from './styles';
import { closeDialog } from '../../../store/dialogs/actions';
import { saveForm } from '../../../store/formEditor/actions';

function EditWarning (props) {
    const { classes, saveForm, form, dialogs, dialogName } = props;

    const closeDialog = () => props.closeDialog(dialogName);

    const handleSave = () => {
        saveForm().then(closeDialog);
    };

    return form && (
        <Dialog
            open={dialogs[dialogName].open}
            onClose={closeDialog}
            fullWidth
        >
            <div className={classes.header}>
                <Typography variant="h6" color="inherit">
                    <ErrorIcon className={classes.icon} />
                    Warning: This form has 1 or more recipient responses
                </Typography>
            </div>
            <DialogContent className={classes.content}>
                <Typography variant='subtitle1'>
                    You are attempting to save changes to a form that has already been set to recipients and has already received one or more responses
                </Typography>
                <Typography className={classes.boldSubtitle} variant='subtitle1'>
                    Are you sure you want to save changes to this form?
                </Typography>
                <Typography variant='subtitle2' className={classes.formName}>{form.name}</Typography>
                <Typography variant='subtitle1' className={classes.italicSubtitle}>
                    NOTE: Changes saved to this form will be presented to future form respondents. Because previous respondents will not have been able to respond to your newly changed fields, these changes could compromise your response data.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>cancel</Button>
                <Button className={classes.saveBtn} onClick={handleSave}>
                    save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = state => ({
    dialogs: state.dialogs,
    form: state.formEditor.form
});

const mapDispatchToProps = dispatch => ({
    saveForm: () => dispatch(saveForm()),
    closeDialog: name => dispatch(closeDialog(name))
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(EditWarning);